import React from 'react'
import Button from 'components/shared/Button'
import './index.scss'

const ChooseProductsButton = (props) => {
  return (
    <Button
      {...props}
      type={null}
      className="choose-products-button"
    />
  )
}

export default ChooseProductsButton
